import React, { Component } from 'react';


export default function asWizard(WrappedComponent) {

    return class extends Component {

        constructor(props) {
            super(props);
            this.state = { step: 0 };
        }

        onBackOrNext = () => {
            // Extrahiert aktuellen "step" aus der Url, wenn vorhanden - hinter #-Zeichen           
            let hash = this.props.location.hash;
            var stepFinderRegex = /step=(\d+)/g;
            var matches = stepFinderRegex.exec(hash);
            if (matches && matches.length >= 2) {
                console.log("Hole 'step' aus History...")
                const step = Number(matches[1]);
                this.setState({ step: step });
            } else {
                this.setState({ step: 0 });
            }

        }


        componentDidMount() {
            window.addEventListener("popstate", this.onBackOrNext);
            //Macht vermutlich eher Sinn den Hash aus der Browserzeile zu löschen, wenn direkt hierüber eingestiegen wird
            // -> dann bei 0 beginnen
            this.setState({step: 0});

            if(this.props.location.hash !== "") {
                this.props.history.push("#");
            }
        }



        componentWillUnmount() {
            window.removeEventListener("popstate", this.onBackOrNext);
        }

        setNextStep = (calculate) => {
            this.setState((prevState) => {
                const newStep = calculate(prevState.step);
                this.props.history.push("#step=" + newStep);
                return { step: newStep };
            });
        }

        next = () => {
            //Setzt nächsten Step im State und setzt step in Browser-History           
            this.setNextStep((prevStep => prevStep + 1));
        }


        previous = () => {
            //Setzt vorherigen Step im State und setzt step in Browser-History
            this.setNextStep((prevStep => prevStep - 1));
        }


        render() {
            return <WrappedComponent step={this.state.step} onNext={this.next} onPrevious={this.previous} {...this.props} />
        }

    }

}


// WEBPACK FOOTER //
// ./src/components/Wizard.js